var _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReports(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 96,
    viewBox: "0 0 80 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.27586 96H71C75.5633 96 79.2759 92.2875 79.2759 87.7241V8.27586C79.2759 3.71255 75.5633 0 71 0H8.27586C3.71255 0 0 3.71255 0 8.27586V87.7241C0 92.2875 3.71255 96 8.27586 96ZM3.31034 8.27586C3.31034 5.53821 5.53821 3.31034 8.27586 3.31034H26.2113H32.347C32.347 3.31034 33.077 3.31034 33.5172 3.31034C33.9575 3.31034 46.7586 3.31034 46.7586 3.31034H47.9288H54.0646H71C73.7377 3.31034 75.9655 5.53821 75.9655 8.27586V87.7241C75.9655 90.4618 73.7377 92.6897 71 92.6897H8.27586C5.53821 92.6897 3.31034 90.4618 3.31034 87.7241V8.27586Z",
    fill: "url(#paint0_linear_4051_28975)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.7972 58.6676C43.7972 58.325 43.6611 57.9965 43.4188 57.7542C43.1766 57.512 42.8481 57.3759 42.5055 57.3759H31.9568C31.6142 57.3759 31.2857 57.512 31.0434 57.7542C30.8012 57.9965 30.6651 58.325 30.6651 58.6676V87.1052C30.6651 87.4478 30.8012 87.7764 31.0434 88.0186C31.2857 88.2608 31.6142 88.3969 31.9568 88.3969H42.5055C42.8481 88.3969 43.1766 88.2608 43.4188 88.0186C43.6611 87.7764 43.7972 87.4478 43.7972 87.1052V58.6676ZM33.2484 59.9593H41.4291V85.5983H33.2484V59.9593Z",
    fill: "url(#paint1_linear_4051_28975)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0539 65.1814C25.0539 64.8388 24.9178 64.5102 24.6756 64.268C24.4333 64.0258 24.1048 63.8897 23.7622 63.8897H13.2135C12.8709 63.8897 12.5424 64.0258 12.3002 64.268C12.0579 64.5102 11.9218 64.8388 11.9218 65.1814V86.89C11.9218 87.2325 12.0579 87.5611 12.3002 87.8033C12.5424 88.0456 12.8709 88.1816 13.2135 88.1816H23.7622C24.1048 88.1816 24.4333 88.0456 24.6756 87.8033C24.9178 87.5611 25.0539 87.2325 25.0539 86.89V65.1814ZM22.6858 85.5983H14.5052V66.473H22.6858V85.5983Z",
    fill: "url(#paint2_linear_4051_28975)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M64.8419 46.3145C64.8419 45.9719 64.7059 45.6434 64.4636 45.4011C64.2214 45.1589 63.8928 45.0228 63.5503 45.0228H53.0016C52.659 45.0228 52.3304 45.1589 52.0882 45.4011C51.846 45.6434 51.7099 45.9719 51.7099 46.3145V87.0231C51.7099 87.3657 51.846 87.6942 52.0882 87.9365C52.3304 88.1787 52.659 88.3148 53.0016 88.3148H63.5503C63.8928 88.3148 64.2214 88.1787 64.4636 87.9365C64.7059 87.6942 64.8419 87.3657 64.8419 87.0231V46.3145ZM62.4739 85.7314H54.2932V47.6062H62.4739V85.7314Z",
    fill: "url(#paint3_linear_4051_28975)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.5795 36.5312C19.7283 36.5309 20.8607 36.2594 21.8847 35.7388C22.9088 35.2182 23.7954 34.4633 24.4726 33.5353L33.3307 35.7033C33.047 36.7491 32.9995 37.8449 33.1916 38.9113C33.3838 39.9777 33.8107 40.988 34.4417 41.869C35.0726 42.75 35.8916 43.4795 36.8393 44.0048C37.7871 44.5301 38.8398 44.8379 39.9212 44.906C41.0027 44.9741 42.0857 44.8008 43.0919 44.3985C44.098 43.9963 45.0021 43.3752 45.7385 42.5804C46.4749 41.7855 47.0253 40.8367 47.3497 39.8029C47.6741 38.769 47.7644 37.6759 47.6141 36.6028L58.9013 25.77C60.0654 26.9939 61.618 27.776 63.2943 27.9831C64.9707 28.1902 66.6669 27.8094 68.0939 26.9057C69.5209 26.0019 70.5902 24.6312 71.1195 23.0272C71.6488 21.4232 71.6054 19.6853 70.9966 18.1097C70.9966 18.1097 70.7748 17.156 69.6209 15.8656C68.4671 14.5752 66.8922 13.7368 65.1775 13.5C63.4627 13.2632 61.7196 13.6434 60.2592 14.5728C58.7987 15.5021 57.7161 16.9202 57.2044 18.5739C56.6927 20.2276 56.7853 22.0093 57.4656 23.6011L46.7162 33.98C46.1102 32.919 45.2474 32.0272 44.207 31.3864C43.1665 30.7457 41.9818 30.3766 40.7616 30.313C39.5414 30.2493 38.3247 30.4932 37.2233 31.0223C36.1219 31.5513 35.171 32.3486 34.4579 33.3408L25.6147 31.1838C26.024 29.7109 25.9608 28.1466 25.4339 26.7115C24.9069 25.2764 23.9429 24.0428 22.6777 23.1847C21.4125 22.3266 19.9098 21.8871 18.3816 21.9284C16.8534 21.9696 15.3766 22.4894 14.1595 23.4146C12.9424 24.3397 12.0463 25.6234 11.5976 27.0849C11.1488 28.5463 11.17 30.1117 11.6582 31.5605C12.1464 33.0092 13.077 34.2682 14.3187 35.16C15.5605 36.0518 17.0508 36.5314 18.5795 36.5312ZM66.8041 16.8084C66.0278 16.2897 65.1152 16.0129 64.1817 16.0129C62.9302 16.0143 61.7304 16.5121 60.8455 17.397C59.9606 18.2819 59.4629 19.4817 59.4614 20.7331C59.4614 21.6667 59.7383 22.5793 60.2569 23.3555C60.7756 24.1318 61.5128 24.7368 62.3753 25.094C63.2378 25.4513 64.1869 25.5448 65.1025 25.3626C66.0182 25.1805 66.8592 24.731 67.5194 24.0708C68.1795 23.4107 68.6291 22.5696 68.8112 21.654C68.9933 20.7384 68.8998 19.7893 68.5426 18.9268C68.1853 18.0643 67.5803 17.3271 66.8041 16.8084ZM43.003 33.6818C42.2267 33.1631 41.3141 32.8863 40.3805 32.8864C39.1291 32.8879 37.9294 33.3857 37.0445 34.2706C36.1596 35.1555 35.6619 36.3552 35.6605 37.6066C35.6605 38.5402 35.9373 39.4528 36.456 40.229C36.9747 41.0053 37.7119 41.6103 38.5744 41.9675C39.4369 42.3248 40.386 42.4183 41.3017 42.2361C42.2173 42.054 43.0584 41.6044 43.7185 40.9442C44.3786 40.2841 44.8282 39.443 45.0103 38.5273C45.1924 37.6117 45.0989 36.6626 44.7416 35.8001C44.3843 34.9376 43.7792 34.2004 43.003 33.6818ZM21.2019 25.302C20.4257 24.7833 19.5131 24.5065 18.5795 24.5065C17.3281 24.5079 16.1282 25.0057 15.2433 25.8907C14.3584 26.7756 13.8607 27.9755 13.8593 29.2269C13.8594 30.1605 14.1362 31.0731 14.6549 31.8493C15.1736 32.6255 15.9108 33.2305 16.7733 33.5877C17.6358 33.9449 18.5849 34.0384 19.5005 33.8562C20.4162 33.6741 21.2572 33.2245 21.9173 32.5644C22.5774 31.9042 23.027 31.0631 23.2091 30.1475C23.3912 29.2319 23.2977 28.2828 22.9404 27.4203C22.5832 26.5578 21.9782 25.8206 21.2019 25.302Z",
    fill: "url(#paint4_linear_4051_28975)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4051_28975",
    x1: -66.5861,
    y1: -4.03211,
    x2: -66.5861,
    y2: 85.7307,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC5C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.129,
    stopColor: "#F35E85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.343,
    stopColor: "#D9659B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.616,
    stopColor: "#B070BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.934,
    stopColor: "#777FF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6A82FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4051_28975",
    x1: -66.5861,
    y1: -4.03211,
    x2: -66.5861,
    y2: 85.7307,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC5C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.129,
    stopColor: "#F35E85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.343,
    stopColor: "#D9659B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.616,
    stopColor: "#B070BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.934,
    stopColor: "#777FF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6A82FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4051_28975",
    x1: -66.5861,
    y1: -4.03211,
    x2: -66.5861,
    y2: 85.7307,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC5C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.129,
    stopColor: "#F35E85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.343,
    stopColor: "#D9659B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.616,
    stopColor: "#B070BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.934,
    stopColor: "#777FF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6A82FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4051_28975",
    x1: -66.5861,
    y1: -4.03211,
    x2: -66.5861,
    y2: 85.7307,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC5C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.129,
    stopColor: "#F35E85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.343,
    stopColor: "#D9659B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.616,
    stopColor: "#B070BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.934,
    stopColor: "#777FF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6A82FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_4051_28975",
    x1: -66.5861,
    y1: -4.03211,
    x2: -66.5861,
    y2: 85.7307,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC5C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.129,
    stopColor: "#F35E85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.343,
    stopColor: "#D9659B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.616,
    stopColor: "#B070BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.934,
    stopColor: "#777FF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6A82FB"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReports);
export default __webpack_public_path__ + "static/media/reports.28b65f4bbbbb7266cc9049560566134f.svg";
export { ForwardRef as ReactComponent };